export default __webpack_public_path__ + "static/media/Widowdusk Padsoles.70e544e0.jpg";